import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Logger from "../../../services/Logger";
import { Box, FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import CustomButton from "../../components/CustomButton";
import KeywordBox from "../../components/KeywordBox";
import AdminGridList from "./AdminGridList";
import GridUpload from "./GridUpload";

const stateOptions = [
    { value: "", label: "All States" },
    { value: "DRAFT", label: "Draft" },
    { value: "READY_TO_REVIEW", label: "Ready to Review" },
    { value: "REVIEWED", label: "Reviewed" },
    { value: "PUBLISHED", label: "Published" },
    { value: "DISCARDED", label: "Discarded" },
];

const freeOptions = [
    { value: "", label: "All Types" },
    { value: "true", label: "Free" },
    { value: "false", label: "Paid" },
];

export default function AdminGridMain() {
    const [keyword, setKeyword] = useState("");
    const [selectedState, setSelectedState] = useState("");
    const [selectedFree, setSelectedFree] = useState("");
    const [openUpload, setOpenUpload] = useState(false);
    const [reload, setReload] = useState();

    useEffect(() => {
        // Logger.log("uef in AdminHiddenWordMain");
    }, []);

    const handleUploadClick = () => {
        setOpenUpload(true);
    };

    return (
        <Grid container spacing={2}>
            <Grid size={{ xs: 12 }} sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', flex: 1 }}>
                    <FormControl size="small" >
                        <InputLabel>Filter by State</InputLabel>
                        <Select
                            value={selectedState}
                            label="Filter by State"
                            onChange={(e) => setSelectedState(e.target.value)}
                            sx={{ minWidth: 150 }}
                        >
                            {stateOptions.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl size="small" >
                        <InputLabel>Filter by Type</InputLabel>
                        <Select
                            value={selectedFree}
                            label="Filter by Type"
                            onChange={(e) => setSelectedFree(e.target.value)}
                            sx={{ minWidth: 140 }}
                        >
                            {freeOptions.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <KeywordBox callback={setKeyword} />
                </Box>
                <CustomButton
                    variant="contained"
                    startIcon={<CloudUploadIcon />}
                    onClick={handleUploadClick}
                >
                    Upload Image
                </CustomButton>
            </Grid>
            <Grid size={{ xs: 12 }}>
                <AdminGridList keyword={keyword} state={selectedState} free={selectedFree} reload={reload} />
            </Grid>
            <Grid size={{ xs: 12 }}>
                <Paper elevation={2} sx={{ p: 2, mb: 2, backgroundColor: '#e3f2fd', border: '1px solid #2196f3' }}>
                    <Typography variant="body1" color="primary" sx={{ fontWeight: 500 }}>
                        Upload a puzzle image. The backend will analyze the image, extract text, and create a puzzle based on it.
                    </Typography>
                </Paper>
            </Grid>

            <GridUpload open={openUpload} setOpen={setOpenUpload} handleSnackBar={() => {}} callback={() => setReload(Date.now())} />
        </Grid>
    );
}

